<script>
import { euroCouponsCouponMethods } from "@state/helpers";

export default {
  name: "EuroCouponsCouponApprove",
  components: {},
  props: {
    instanceJson: {
      type: Object,
      required: true,
    },
    oncomplete: {
      type: Function,
      required: false,
      default: () => ({}),
    },
    oncancel: {
      type: Function,
      required: false,
      default: () => ({}),
    },
    action: {
      type: String,
      default: "approve",
    },
  },
  data() {
    return {
      modalShow: true,
      loading: true,
      submitting: false,
      toDelete: {},
    };
  },
  computed: {},

  mounted: function () {
    let context = this;
    if (context.instanceJson.url) {
      context.toDelete = {
        ...context.instanceJson,
      };
      context.getObject();
    } else {
      context.oncancel();
    }
  },

  methods: {
    ...euroCouponsCouponMethods,

    getObject() {
      let context = this;
      const promise = context.fetchEuroCouponsCouponDetail(context.toDelete.url);
      return promise
        .then((data) => {
          context.toDelete = { ...data };
          context.loading = false;
        })
        .catch((error) => {
          context.$axios_error_noty(error, context);
          context.loading = false;
          context.oncancel();
        });
    },

    approveObject() {
      let context = this;
      context.submitting = true;
      let payload = {
        action: "approve",
        coupons: [this.toDelete],
      };
      if (this.action == "send_messages") {
        payload.action = "send_message";
      }
      const promise = context.approveInactiveEuroCouponsCoupon(payload);
      return promise
        .then((data) => {
          context.$generate_toast(
            context,
            "success",
            `${context.$t("coupon")} ${context.$t("approved")} ${context.$t("correctly")}`
          );
          setTimeout(() => {
            context.submitting = false;
            context.oncomplete();
            if (data.length) {
              this.$emit("showError", data);
            }
          }, 1000);
        })
        .catch((error) => {
          context.submitting = false;
          context.$axios_error_noty(error, context);
        });
    },
  },
};
</script>

<template>
  <b-modal
    id="delete-modal"
    v-model="modalShow"
    :title="
      action == 'approve'
        ? `${$t('Approve')} ${$t('coupon')}`
        : `${$t('Re-enviar mensaje')} ${$t('coupon')}`
    "
    ok-title="Delete"
    ok-variant="danger"
    @hidden="oncancel"
    @ok.prevent="approveObject"
  >
    <b-container class="p-0">
      <b-row v-if="loading">
        <b-col md="12">
          <div class="text-center">
            <b-spinner
              label="Spinning"
              style="color: #195db2; width: 4rem; height: 4rem"
            ></b-spinner>
          </div>
        </b-col>
      </b-row>
      <b-row v-else>
        <b-col md="12">
          <p class="text-center">
            {{
              action == "approve"
                ? `${$t("¿Estas seguro de aprobar el ")} ${$t("coupon")}`
                : `${$t("¿Estas seguro de re-enviar el mensaje al ")}${$t("coupon")} `
            }}

            {{ toDelete.name || toDelete.id }}?
          </p>
        </b-col>
      </b-row>
    </b-container>
    <template v-slot:modal-footer="{ ok, cancel }">
      <b-button size="sm" variant="secondary" :disabled="submitting" @click="cancel">
        Cancelar
      </b-button>
      <b-button size="sm" variant="success" :disabled="submitting" @click="ok">
        <span v-if="!submitting">
          {{ $t("Approve") }}
        </span>
        <b-spinner v-if="submitting" small label="Spinning" variant="light"> </b-spinner>
      </b-button>
    </template>
  </b-modal>
</template>
<style lang="scss"></style>
